import { tokensToRems, createExact } from '../utilities.mjs';
import { border } from '../token-groups/border.mjs';
import { breakpoints } from '../token-groups/breakpoints.mjs';
import { color } from '../token-groups/color.mjs';
import { font } from '../token-groups/font.mjs';
import { motion } from '../token-groups/motion.mjs';
import { shadow } from '../token-groups/shadow.mjs';
import { space } from '../token-groups/space.mjs';
import { zIndex } from '../token-groups/zIndex.mjs';

var createMetaThemeBase = createExact();
var metaThemeBase = createMetaThemeBase({
  breakpoints: tokensToRems(breakpoints),
  border: tokensToRems(border),
  color: color,
  font: tokensToRems(font),
  motion: motion,
  shadow: tokensToRems(shadow),
  space: tokensToRems(space),
  zIndex: zIndex
});

export { metaThemeBase };
